module.exports = __webpack_public_path__ + "img/taste-table2.f078eafc.png";